<template>
    <div class="breadcrumb">
        <slot></slot>
    </div>
</template>

<script>
	export default {
		name: 'Breadcrumb'
	}
</script>

<style lang="scss" scoped>
    .breadcrumb {
        background: #fff;
        border-bottom: 2px solid #ececec;
        padding: 2px 150px 2px 30px;
        position:relative;

        a{
            color: #c1c1c1;
            padding: 0 25px 8px 25px;
			line-height:37px;
        }

        a.active{
			color: #3D4043;
            border-bottom: 3px solid #38b7ea;
        }

		a.active:not(:first-child){
			margin-left:25px;
		}

		span{
			font-weight:bold;
		}

		@media only screen and (max-width: 800px) {
			display:none;
		}
    }
</style>
